/*
 * Copyright © 2017-2026 Knowledge for Decisions (K4D). All rights reserved.
 *
 * This code and associated materials are protected by copyright laws and international
 * treaties. Unauthorized use, reproduction, distribution, or modification of any content
 * from Knowledge for Decisions (K4D) is strictly prohibited. For inquiries regarding
 * the use or licensing of K4D's copyrighted materials, please contact us at
 * contact@k4d.com.br. "Knowledge for Decisions (K4D)" and the slogan "Using data to make
 * precise decisions" are registered trademarks of Knowledge for Decisions (K4D).
 */

import { findElementFromField } from './scroll-to-field-highlight-find';
import { applyHighlight } from './scroll-to-field-highlight-apply';

/**
 * Gets element to highlight.
 * 
 * @param {HTMLElement} fieldElement - Field element
 * @param {HTMLElement | null} containerElement - Container element
 * @returns {HTMLElement | null} Element to highlight
 */
function getElementToHighlight(
  fieldElement: HTMLElement,
  containerElement: HTMLElement | null
): HTMLElement | null {
  if (containerElement) {
    return containerElement;
  }
  return findElementFromField(fieldElement);
}

/**
 * Highlights field element with animation.
 * 
 * @param {HTMLElement} fieldElement - Field element to highlight
 * @param {HTMLElement | null} containerElement - Container element if available
 * @returns {void}
 */
export function highlightField(fieldElement: HTMLElement, containerElement: HTMLElement | null): void {
  const elementToHighlight = getElementToHighlight(fieldElement, containerElement);
  if (!elementToHighlight) {
    return;
  }
  applyHighlight(elementToHighlight);
}
